import { format, parseISO } from "date-fns"


export default function formatDate(date) {
  const stringDate = parseISO(date)
  const getDate = new Date(stringDate)
  const formattedDate = format(getDate, "dd/MM/yyyy")
  return formattedDate
}